// src/components/Seo.jsx

import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://www.revoltantsolarsolution.in';

export default function Seo({ title, description, path = '/' }) {
  const url = `${SITE}${path}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </Helmet>
  );
}